import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { CatalogFilterBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { z } from 'zod/v4';

// Seletor "Kind" do catálogo sem o tipo Location: Location é só o ponteiro
// de onde o Backstage leu cada fonte (app-config, catalog.locations), não é
// um recurso da plataforma, e só confundia quem abre o catálogo. As entidades
// continuam existindo e sendo processadas normalmente, só somem do filtro.
// Sobrescreve o filtro "kind" do plugin catalog (mesmo id), mantendo o
// initialFilter configurável como no original.
const ALLOWED_KINDS = [
  'Component',
  'API',
  'System',
  'Domain',
  'Resource',
  'Group',
  'User',
  'Template',
];

const kindFilter = CatalogFilterBlueprint.makeWithOverrides({
  name: 'kind',
  configSchema: {
    initialFilter: z.string().default('component'),
  },
  factory(originalFactory, { config }) {
    return originalFactory({
      loader: async () => {
        const { EntityKindPicker } = await import(
          '@backstage/plugin-catalog-react'
        );
        return (
          <EntityKindPicker
            allowedKinds={ALLOWED_KINDS}
            initialFilter={config.initialFilter}
          />
        );
      },
    });
  },
});

export const catalogKindsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [kindFilter],
});
